/**
 * CustomLink拡張機能
 * TipTapのLink拡張機能を拡張し、参照形式リンクのメタデータを保持する
 */

import Link from '@tiptap/extension-link';

/**
 * isReferenceとreferenceId属性を追加したカスタムLink拡張機能
 * これにより、参照形式リンクのメタデータがエディタ内で保持される
 */
export const CustomLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      isReference: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-is-reference') === 'true',
        renderHTML: (attributes) => {
          if (!attributes.isReference) {
            return {};
          }
          return { 'data-is-reference': 'true' };
        },
      },
      referenceId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-reference-id'),
        renderHTML: (attributes) => {
          if (!attributes.referenceId) {
            return {};
          }
          return { 'data-reference-id': attributes.referenceId };
        },
      },
    };
  },
});

export default CustomLink;
